import { toUpperCase } from '@/utils/string';
const SPLIT_NAME_REGEX = /[\s-./]+/;
const segmenter = new Intl.Segmenter();

/**
 * 名前の一部から最初の文字を抽出します。
 * @param {string} part - 名前の一部。
 * @returns {string} - 名前の一部の最初の文字。
 */
const extractInitial = (part: string): string => {
  const segments = Array.from(segmenter.segment(part));
  return segments.at(0)?.segment ?? '';
};

/**
 * フルネームを構成要素に分割します。
 * @param {string} name - 分割するフルネーム。
 * @returns {string[]} - 名前の部分の配列。
 */
const splitNameIntoParts = (name: string): string[] => name.trim().split(SPLIT_NAME_REGEX).filter(Boolean);

/**
 * フルネームからイニシャル2文字を生成します。
 * @param {string} name - イニシャルを生成するフルネーム。
 *  * @returns {string} - 大文字のイニシャル。
 */
export const genNameInitials = (name: string, maxLength = 2): Uppercase<string> => {
  const initials = splitNameIntoParts(name).map(extractInitial).join('');
  const result = initials.slice(0, maxLength);
  return toUpperCase(result);
};